import { FC, useState } from "react";
import { Stack, Typography } from "@mui/material";
import { Modal } from "@/components/elements/Modal";
import { Button } from "@/components/elements/Button";
import { IconFileImport } from "@/assets/icons";
import { button, text } from "@/theme/colors";

type TCsvExportModalProps = {
  open: boolean;
  onClose: () => void;
  onExportCompany: () => void;
  onExportTalent: () => void;
  showClassificationWarning?: boolean;
  showCompanyClassificationWarning?: boolean;
};

export const CsvExportModal: FC<TCsvExportModalProps> = ({
  open,
  onClose,
  onExportCompany,
  onExportTalent,
  showClassificationWarning,
  showCompanyClassificationWarning,
}) => {
  const [talentConfirmOpen, setTalentConfirmOpen] = useState(false);
  const [companyConfirmOpen, setCompanyConfirmOpen] = useState(false);

  const handleTalentExportClick = async () => {
    if (showClassificationWarning) {
      setTalentConfirmOpen(true);
    } else {
      await onExportTalent();
    }
  };

  const handleCompanyExportClick = async () => {
    if (showCompanyClassificationWarning) {
      setCompanyConfirmOpen(true);
    } else {
      await onExportCompany();
    }
  };

  const handleTalentConfirmExport = async () => {
    setTalentConfirmOpen(false);
    await onExportTalent();
  };

  const handleCompanyConfirmExport = async () => {
    setCompanyConfirmOpen(false);
    await onExportCompany();
  };

  const handleClose = () => {
    setTalentConfirmOpen(false);
    setCompanyConfirmOpen(false);
    onClose();
  };

  return (
    <>
      <Modal isOpen={open} onClose={handleClose} title="CSV取得" enableFooter={false} width={600}>
        <Typography variant="body14" color={text.secondary} sx={{ mt: 1, mb: 2 }}>
          irohana visaへ企業または人材の登録用CSVを出力できます。
        </Typography>
        <Stack direction="row" justifyContent="space-between" gap={2} mt={3}>
          <Button
            variant="outline"
            size="sm"
            startIcon={<IconFileImport color={button.primary} width={20} height={20} />}
            onClick={handleCompanyExportClick}
          >
            企業CSVの取得
          </Button>
          <Button
            variant="outline"
            size="sm"
            startIcon={<IconFileImport color={button.primary} width={20} height={20} />}
            onClick={handleTalentExportClick}
          >
            人材CSVの取得
          </Button>
        </Stack>
      </Modal>

      {/* Talent classification mismatch confirmation */}
      <Modal isOpen={talentConfirmOpen} onClose={() => setTalentConfirmOpen(false)} onOk={handleTalentConfirmExport} width={500} title="確認">
        <Typography variant="body14" color={text.primary}>
          人材の区分が空欄か、求人の区分と異なっています。
        </Typography>
        <Stack mt={1} mb={2}>
          <Typography variant="body14" color={text.primary}>
            CSVは求人の区分で出力いたしますが、よろしいでしょうか。
          </Typography>
        </Stack>
      </Modal>

      {/* Company classification mismatch confirmation */}
      <Modal isOpen={companyConfirmOpen} onClose={() => setCompanyConfirmOpen(false)} onOk={handleCompanyConfirmExport} width={500} title="確認">
        <Typography variant="body14" color={text.primary}>
          企業の分野・区分①が、求人の分野・区分と異なっています。
        </Typography>
        <Stack mt={1} mb={2}>
          <Typography variant="body14" color={text.primary}>
            CSVは企業の分野・区分①で出力いたしますが、よろしいでしょうか。
          </Typography>
        </Stack>
      </Modal>
    </>
  );
};
